import SelectorEngine from '../../utils/dom/selector-engine';
import { startLoadingAnimation, stopLoadingAnimation } from '../../utils/dom/loading';
import Request, { ApiMode } from '../../utils/request';

import Manipulator from '../../utils/dom/manipulator';

const CLICK_EVENT = 'click';
const HIDE_CLASS = 'u-hidden';
const IS_LOCAL = false;
class ContentFeedback {
	constructor() {
		this.likeBtnClass = 'like-btn-wrapper';
		this.feedbackWrapperClass = 'feedback-icon-wrapper';
		this.successFeedbackClass = 'feedback-success';
		this.likesWrapperClass = 'content-likes';
		this.dislike_btn = 'dislike-btn';
		this._container = SelectorEngine.findOne('.content-feedback-container');
		if (!this._container) {
			return;
		}
		this.init();
	}

	init() {
		const selectElement = SelectorEngine.findOne(`.${this.likeBtnClass}`, this._element);
		const replaceWrapper = SelectorEngine.findOne(`.${this.feedbackWrapperClass}`, this._element);
		const feedbackTextWrapper = SelectorEngine.findOne(`.${this.successFeedbackClass}`, this._element);
		const likesWrapper = SelectorEngine.findOne(`.${this.likesWrapperClass}`, this._element);
		const likesCount = SelectorEngine.findOne('.content-likes', this._element);
		const dislikeWrapper = SelectorEngine.findOne(`.${this.dislike_btn}`, this._element);
		const contentId = Manipulator.getDataAttribute(likesWrapper, 'content-id');
		const likes = Manipulator.getDataAttribute(likesWrapper, 'likes');

		if (likes) {
			likesCount.innerHTML = Number(likes);
		}
 
		selectElement.addEventListener(CLICK_EVENT, () => {
			this.updateContentFeedback(replaceWrapper, contentId, true, feedbackTextWrapper, likesCount,likes);
		});

		dislikeWrapper.addEventListener(CLICK_EVENT, () => {
			this.updateContentFeedback(replaceWrapper, contentId, false, feedbackTextWrapper, likesCount,likes);
		});
	}

	async updateContentFeedback(replaceWrapper, contentId, isLike, feedbackEvent, likesCount,likes) {
		try {
			startLoadingAnimation(true);
			const apiUrl = '/api/rating/addrating';
			const responseData = await Request.post(
				apiUrl,
				{
					contentId: contentId,
					isLike: isLike
				},
				{
					local: IS_LOCAL,
					req: {
						apiMode: ApiMode.LtaError
					}
				}
			);
			const { IsSuccess } = responseData;
			if (IsSuccess) {
				replaceWrapper?.classList?.add(HIDE_CLASS);
				feedbackEvent?.classList.remove(HIDE_CLASS);
				if (isLike) {
					likesCount.innerHTML = Number(++likes);
				}
			}
			//TODO: Error Handling scenario
		} catch {
			// eslint-disable-next-line no-console
			console.log('Error', Error);
		} finally {
			stopLoadingAnimation(true);
		}
	}
}

const feedbackComponent = new ContentFeedback();

export default feedbackComponent;
